/**
 * JSP page names.
 */
export enum Page {
    WELCOME = 'Welcome',
    REPORTING = 'Reporting',
    INSIGHTS_HUB = 'InsightsHub',
    PRESENCE = 'Presence',
    EASY_PROVISIONING = 'EasyProvisioning',
    ADMINISTRATION = 'Administration',
    STATUSANDTOOLS = 'StatusAndTools',
    ADMIN_AGENTS = 'AdminACDAgents',
    ADMIN_CLIENT_CONFIGURATION = 'AdminClientConfiguration',
    ADMIN_DIRECTORY = 'AdminDirectory',
    ADMIN_DEVICES = 'AdminDevices',
    ADMIN_CODES = 'AdminCodes',
    ADMIN_PARTITIONS = 'AdminPartitions',
    ADMIN_TELSYSS = 'AdminTelSyss',
    ADMIN_CMENVIRONMENTS = 'AdminCMEnvironments',
    ADMIN_USERS = 'AdminUsers',
    ADMIN_CRM_CONFIGURATION = 'AdminCRMConfiguration',
    ADMIN_OCHINTS = 'AdminOmniChannelInts',
    ADMIN_CALLRECINTS = 'AdminCallRecInts',
    ADMIN_MESSAGES = 'AdminMessages',
    ADMIN_DATABASE = 'AdminDatabase',
    ADMIN_LOGGING = 'AdminLogging',
    LICENSEMGR = 'LicenseMgr',
    LOGFILEMGR = 'LogfileMgr',
    AUDITTRAIL = 'AuditTrail',
    TELMODULE_STATUS = 'TelModuleStatus',
    TELMODULE_CALLCTRL = 'TelModuleCallCtrl',
    APP_STATUS = 'AppStatus'
}
